export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/neill-kumar-8e220f682d44ddb844ecf60df543b8c4.jpg";